import WisdomLogo from "../../medias/images/Wisdom logo transparent.png";
import "./ApplicantSignIn.css";
import React, { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import { Toast } from "primereact/toast";
import { requestAuthApplicantLogin, requestResetPassword, requestUpdatePassword } from "../../services/wisdomServices/authService";
import { getSessionItem, removeSessionItem } from "../../utils/helper/session";
import { Button } from "primereact/button";
import { InputOtp } from "primereact/inputotp";
import { useNavigate } from "react-router-dom";
import { Password } from "primereact/password";

function ApplicantSignIn() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear()
  const toast = useRef(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false); 
  const [forgotStep, setForgotStep] = useState(0);
  const [forgotPassword , setForgotPassword ] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,})/;

  const getEmailNameParts = (email) => {
    if (!email) return [];

    const namePart = email.split("@")[0];

    return namePart
      .split(/[._-]/)
      .filter(Boolean)
      .map((part) => part.toLowerCase());
  };

  const emailNameParts = getEmailNameParts(email);

  const containsEmailName = emailNameParts.some((part) =>
    part.length >= 3 &&
    newPassword.toLowerCase().includes(part)
  );

  const isStrongPassword = strongPasswordRegex.test(newPassword);

  const isPasswordValid = isStrongPassword && !containsEmailName;
    

  const showError = (text) => {
    toast.current.show({ severity: 'error', summary: 'Error', detail: text, life: 3000 });
  };

  const login = async () => {
    setIsLoading(true); 
    let keys = {
        email,
        password,
        sso:false
    };
    try {
      removeSessionItem("User");
      await requestAuthApplicantLogin(keys);
      let user = getSessionItem("User");
      if (user) {
        window.location.href = "/profile/info";
      } else {
        showError('Wrong username or password');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); 
    }
  };

  const handleClearFields = async() => {
    setEmail('')
    setPassword('')
  }

  const handleSendResetEmail = async () => {
    if (!email) {
      showError("Please enter your email");
      return;
    }

    try {
      setIsLoading(true);
      await requestResetPassword(email)
      setForgotStep(2);
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false);
      setForgotStep(2);
    }
  };

  const handleResetPassword = async () => {
    if (!otpCode || !newPassword || !confirmPassword) {
      showError("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      showError("Passwords do not match");
      return;
    }

    try {
      setIsLoading(true);
      await requestUpdatePassword(email, otpCode, newPassword);
      setForgotStep(0);
      setForgotPassword(false);
      setEmail("")
      setNewPassword("")
      setConfirmPassword("")
      setOtpCode("")
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getStepContent = () => {
    if (!forgotPassword) {
      return {
        title: "Welcome to Sirius Support\nApplicant Portal",
        subtitle: "Use your best email and provided password to login"
      };
    }

    if (forgotStep === 1) {
      return {
        title: "Reset Your Password",
        subtitle: "Enter your email to receive a verification code"
      };
    }

    if (forgotStep === 2) {
      return {
        title: "Verify & Create New Password",
        subtitle: "Enter the verification code sent to your email and choose a new password"
      };
    }

    return {};
  };

  useEffect(() => {
    if (password !== '' || email !== '') {
      const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          login();
        }
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [login]);

  const { title, subtitle } = getStepContent();

  const passwordsMatch =
    newPassword &&
    confirmPassword &&
    newPassword === confirmPassword;

  const passwordsDoNotMatch =
    confirmPassword &&
    newPassword !== confirmPassword;

  return (
      <div className="applicant-login-main-container">
        <Toast ref={toast} position="top-center" />
        {isLoading && (
            <div className="loading-overlay">
            <LoadingSpinner />
            </div>
        )} 
        <div className="floating-applicant-login-container">
          <img className="wisdom-logo-img" src={WisdomLogo} alt="Wisdom Logo" />
          <div className="sign-in-page-section">
            <div className="signIn-btns">
              <hr className="divider" />
              <p className="signed-header">
                {title.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
              <p>{subtitle}</p>
              {!forgotPassword && (
                <>
                  <input
                    className="login-page-input-text"
                    type="email"
                    value={email}
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />

                  <input
                    className="login-page-input-text"
                    type="password"
                    value={password}
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                  />

                  <div className="applicant-login-btns-box">
                    <Button
                      link
                      label="Forgot Password"
                      icon="pi pi-exclamation-circle"
                      severity="help"
                      onClick={() => {
                        setForgotPassword(true);
                        setForgotStep(1);
                      }}
                    />

                    <div className="applicant-login-action-btns">
                      {/* <div>
                        <Button 
                          label="Back"
                          icon="pi pi-arrow-left"
                          severity="info"
                          onClick={() => navigate('/')}
                        />
                      </div> */}
                      <div className="applicant-login-btns">
                        <Button
                          label="Login"
                          icon="pi pi-sign-in"
                          severity="success"
                          onClick={login}
                          disabled={isLoading || email === '' || password === ''}
                        />
                        <Button
                          label="Clear"
                          icon="pi pi-times"
                          severity="warning"
                          onClick={handleClearFields}
                        />
                      </div>
                    </div>
                    <div className="signup-section">
                      <span>Don’t have an account? </span>
                      <a
                        className="signup-link"
                        onClick={() => navigate("/applicant/sign-up")}
                      >
                        Sign up
                      </a>
                    </div>
                  </div>
                </>
              )}
              {forgotPassword && forgotStep === 1 && (
                <>
                  <input
                    className="login-page-input-text"
                    type="email"
                    value={email}
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                  />

                  <Button
                    label="Send"
                    icon="pi pi-send"
                    severity="info"
                    onClick={handleSendResetEmail}
                    disabled={isLoading || !email}
                  />

                  <Button
                    link
                    label="Back to login"
                    onClick={() => {
                      setForgotPassword(false);
                      setForgotStep(0);
                    }}
                  />
                </>
              )}
              {forgotPassword && forgotStep === 2 && (
                <>
                  <InputOtp
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.value)}
                    length={6}
                    disabled={isLoading}
                    className={`custom-otp custom-otp-input ${otpCode?.length === 6 ? "otp-complete" : ""}`}
                  />

                  <div className="password-input-wrapper">
                    <Password
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      toggleMask
                      feedback={false} 
                      placeholder="New password"
                      disabled={isLoading}
                    />

                    {newPassword && !isStrongPassword && (
                      <small className="password-error">
                        Password must contain:
                        <br />• Minimum 8 characters
                        <br />• At least 1 uppercase letter
                        <br />• At least 1 lowercase letter
                        <br />• At least 1 special character
                      </small>
                    )}

                    {newPassword && containsEmailName && (
                      <small className="password-error">
                        <br />• Password cannot contain parts of your email.
                      </small>
                    )}
                  </div>

                  <div className="password-input-wrapper">
                    <Password
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      toggleMask
                      feedback={false} 
                      placeholder="Confirm new password"
                      className="login-page-input-password"
                      disabled={isLoading}
                    />
                  </div>
                  {passwordsDoNotMatch && (
                    <small className="password-error">
                      Passwords do not match
                    </small>
                  )}

                  {passwordsMatch && (
                    <small className="password-success">
                      Passwords match
                    </small>
                  )}

                  <Button
                    label="Reset Password"
                    icon="pi pi-check"
                    severity="success"
                    onClick={handleResetPassword}
                    disabled={
                      isLoading ||
                      !otpCode ||
                      otpCode.length < 6 ||
                      !newPassword ||
                      !confirmPassword ||
                      newPassword !== confirmPassword ||
                      !isPasswordValid
                    }
                  />

                  <Button
                    link
                    label="Back"
                    onClick={() => setForgotStep(1)}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        <footer className="applicant-login-page-footer">
            <div>
            <a href="https://sirius-support.com/terms-of-service/" target="_blank">Terms of Service</a> | <a href="https://sirius-support.com/privacy-policy/" target="_blank">Privacy Policy</a>
            </div>
            <div>
            <p>&copy; {currentYear} <a href='https://sirius-support.com' target="_blank">Sirius Support</a></p>
            </div>
        </footer>
    </div>
  );
}

export default ApplicantSignIn;
